import React, { useEffect } from 'react'
import { useAccountByUserContext } from './index.context'
import { useNavigate } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import { TABLE_NAME } from 'src/app/shared/constants/tableName.constants'
import { useRolePermission } from 'src/app/shared/hooks/useRolePermission'
import { EPermissions, ESubModules } from 'src/app/shared/models/roleAndPermission.model'
import NewCommonTable from 'src/app/shared/components/common/new-table'
import { getAccountByUser, getAccountsDownloadFile, getAccountsDownloadStatus } from 'src/app/shared/services/AccountService'
import { settingHeightTableWithFilter } from 'src/app/shared/constants/common.constants'

const AccountByUserTabContent: React.FC<{ onUpload: () => any; resetView: boolean }> = ({ onUpload, resetView }) => {
  const navigate = useNavigate()
  const { accountByUser, total, isLoading, handleSearch, getActionItems } = useAccountByUserContext()
  const { userPermissions, role } = useRolePermission()

  useEffect(() => {
    if (resetView) {
      handleSearch({
        pageIndex: 1,
        pageSize: 50,
        sortColumnsDictionary: { user: 'asc', client: 'asc', accountName: 'asc' },
      })
    }
  }, [resetView])

  return (
    <NewCommonTable
      rowData={accountByUser}
      total={total}
      displayActionColumn={false}
      loading={isLoading}
      handleUpload={onUpload}
      translationNamespace='AccountSetup:account_by_user_list'
      pageName={TABLE_NAME.ACCOUNTS_BY_USER}
      tableSettingName={TABLE_NAME.ACCOUNTS_BY_USER}
      displayAddBtn={userPermissions[ESubModules.ACC_SET]?.includes(EPermissions.ADD_EDIT_ITEMS)}
      displayUploadButton={
        role === 'Bank User' && userPermissions[ESubModules.ACC_SET]?.includes(EPermissions.ADD_EDIT_ITEMS)
      }
      displayDownloadBtn={
        userPermissions[ESubModules.ACC_SET]?.includes(EPermissions.VIEW_ITEMS) ||
        userPermissions[ESubModules.ACC_SET]?.includes(EPermissions.ADD_EDIT_ITEMS)
      }
      handleSearch={handleSearch}
      handleDownload={async (payload) => await getAccountByUser(payload as any)}
      getDownloadStatus={getAccountsDownloadStatus}
      getDownloadFile={getAccountsDownloadFile}
      actionDropdownItems={getActionItems}
      handleAddRecord={() => navigate(`${menuUrls.accountSetup}/add`)}
      settingHeightTable={settingHeightTableWithFilter}
    />
  )
}

export default AccountByUserTabContent
